import {connect} from 'react-redux';
import {fetchTimeSensitiveItemType} from 'src/redux/admin/actions/timeSensitiveItemTypes';
import EditForm from './EditForm';

export default connect(null, {fetchTimeSensitiveItemType})(EditForm);
